import { alertService as baseService } from '../alert.base.service';

const service = {

};

export const alertService = Object.assign(baseService, service)
